import { render, staticRenderFns } from "./collectioncode-tracking.vue?vue&type=template&id=52976386&"
import script from "./collectioncode-tracking.vue?vue&type=script&lang=ts&"
export * from "./collectioncode-tracking.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports